export enum PartnerUserProviderType {
  WSC = 'WSC',
  Google = 'Google',
}

export const PARTNERS_LOGIN_API_PATH = 'PartnersLogin'
